function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.99 15.53c-.61-.54-1.19-1.06-1.74-1.54C2.79 10.93.5 8.91.5 6.25.5 3.95 2 2.21 4 2.21c2.22 0 3.64 1.3 3.66 1.31l.34.32.34-.32S9.78 2.21 12 2.21c2 0 3.5 1.74 3.5 4.04 0 2.66-2.29 4.68-5.76 7.74-.55.49-1.13 1-1.74 1.55l-.01-.01z",
  stroke: "#D44400",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHeart;